import { css } from '@emotion/react';
import { theme } from '../../../design-system/theme/theme';

/* 카드 폭 20rem — 시안 w-80 스냅. */
export const cardStyle = css`
  width: 20rem;
  padding: ${theme.space.lg}px;
  border-radius: ${theme.radius.md}px;
  background: ${theme.color.surface};
`;

export const brandStyle = css`
  text-align: center;
  margin-bottom: ${theme.space.lg}px;
  font-size: ${theme.fontSize.xl}px;
  font-weight: 700;
  color: ${theme.color.text};

  p {
    margin: ${theme.space.xs}px 0 0;
    font-size: ${theme.fontSize.sm}px;
    font-weight: 400;
    color: ${theme.color.textMuted};
  }
`;

export const fieldLabelStyle = css`
  display: block;
  margin-bottom: ${theme.space.xs}px;
  font-size: ${theme.fontSize.sm}px;
  color: ${theme.color.textMuted};
`;

export const fieldStyle = css`
  margin-bottom: ${theme.space.md}px;

  input {
    width: 100%;
    box-sizing: border-box;
  }
`;

export const submitRowStyle = css`
  display: flex;

  button {
    flex: 1;
    justify-content: center;
  }
`;

export const footnoteStyle = css`
  margin: ${theme.space.md}px 0 0;
  text-align: center;
  font-size: ${theme.fontSize.sm}px;
  color: ${theme.color.textMuted};
`;
